import {Component, Inject, OnInit} from '@angular/core';
import {ApplicationService} from '../../../services/application_service.service';
import {Application} from '../../../models/application.model';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'customer-application-dialog',
    templateUrl: './customer_application_dialog.component.html',
    styleUrls: ['./customer_application_dialog.component.scss'],
    imports: [MatProgressBar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatTooltip, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, MatDialogClose, DatePipe]
})
export class CustomerApplicationDialogComponent implements OnInit {

    displayedColumns: string[] = ['updateDate', 'applicationStatus', 'discount', 'actions'];
    applications: Application[] = [];
    loading = true;
    errorMessage: string | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { id: string },
        private applicationService: ApplicationService,
    ) {
    }

    ngOnInit(): void {
        // fetch service applications
        this.load();
    }

    load(): void {
        this.loading = true;
        this.errorMessage = null;

        this.applicationService.getAll(['all'], new Map([['userId', this.data.id]]))
            .subscribe(response => {
            this.applications = response;
            this.loading = false;
        }, (error) => {
            this.loading = false;
            this.errorMessage = error;
        });
    }
}
